import ChainsChip from '@/app/dashboard/deposit/chains_chip'
import { Button } from '@/cn/ui/button'
import { chainLogos } from '@/config/chains_logo'
import { CHAIN_ID, NETWORKS } from '@/constants'
import { IUser } from '@/interface'
import { popup } from '@/popup_handler'
import { useAppStore } from '@/store'
import { CopyButton, QR } from '@/ui'
import { TitleBar } from '@/ui/titlebar'
import { prettifyAddress, queryClient } from '@/utils'
import { OnrampWebSDK } from '@onramp.money/onramp-web-sdk'
const buyNow = (chain: typeof NETWORKS, walletAddress: string) => {
  const appId = chain.testnet ? 2 : import.meta.env.VITE_ONRAMP_APP_ID
  let coinCode, network
  if (!chain.testnet) {
    coinCode = 'usdc'
    switch (chain.id) {
      case CHAIN_ID.BASE:
      case CHAIN_ID.BASE_SEPOLIA_CHAIN_ID:
        network = 'base'
        break
      case CHAIN_ID.POLYGON:
      case CHAIN_ID.POLYGON_AMOY_CHAIN_ID:
        network = 'matic20'
        break
      case CHAIN_ID.ARBITRUM:
      case CHAIN_ID.ARB_SEPOLIA_CHAIN_ID:
        network = 'arbitrum'
        break
      case CHAIN_ID.OPTIMISM:
      case CHAIN_ID.OP_SEPOLIA_CHAIN_ID:
        network = 'optimism'
        break
    }
  }
  const onrampInstance = new OnrampWebSDK({
    appId,
    walletAddress,
    flowType: 1, // 1 -> onramp || 2 -> offramp || 3 -> Merchant checkout
    fiatType: 1, // 1 -> INR || 2 -> TRY || 3 -> AED || 4 -> MXN || 5-> VND || 6 -> NGN etc. visit Fiat Currencies page to view full list of supported fiat currencies
    ...(!chain.testnet && {
      coinCode,
      network,
    }),
    paymentMethod: 1, // 1 -> Instant transafer(UPI) || 2 -> Bank transfer(IMPS/FAST)
    theme: {
      lightMode: {
        baseColor: '#F96900', // * required (hex code e.g. #XXXXXX)
        // inputRadius: string;  //optional (in px e.g. 20px)
        // buttonRadius: string; //optional (in px e.g. 10px)
      },
      darkMode: {
        baseColor: '#F96900', // * required (hex code e.g. #XXXXXX)
        // inputRadius: string;  //optional (in px e.g. 20px)
        // buttonRadius: string; //optional (in px e.g. 10px)
      },
    },
  })
  onrampInstance.show()
}
const DepositScreen = () => {
  const user = (queryClient.getQueryData(['user']) || {}) as IUser
  const { wallet } = useAppStore((state) => state) as any

  //@ts-ignore
  const handleBuyNow = () => {
    buyNow(NETWORKS?.[user?.default_chain], wallet?.address)
  }
  return (
    <div className="flex flex-col gap-4 p-4 h-full w-full">
      <TitleBar title="Topup" navClassName="sticky top-0" />
      <div className="flex flex-col items-center gap-2">
        <p>Top up USDC on</p>
        <ChainsChip chainLogos={chainLogos} />
      </div>

      <div className="flex flex-col justify-center items-center gap-4">
        <QR data={wallet?.address} className="w-48" />
        <div className="flex items-center gap-3">
          <p className=" text-sm">{prettifyAddress(wallet?.address)}</p>
          <CopyButton value={wallet?.address} />
        </div>
      </div>
      <div className="flex items-center gap-2">
        <div className="h-[1px] w-full bg-black"></div>
        OR
        <div className="h-[1px] w-full bg-black"></div>
      </div>
      <Button
        // onClick={handleBuyNow}
        onClick={() => popup.open('onramp')}
      >
        Top up from bank
      </Button>
    </div>
  )
}
export default DepositScreen
